// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1WCXR","content":"styles_content__2vQAL","checkbox":"styles_checkbox__1TKYE","checkboxLabel":"styles_checkboxLabel__7PnfK"};